import { defineMessages } from 'react-intl';

export default defineMessages({
  AvailabilityHeading: {
    id: 'JobDetailSection.Availability.Heading',
    defaultMessage: 'Availability',
  },
  ExperienceHeading: {
    id: 'JobDetailSection.Experience.Heading',
    defaultMessage: 'Experience',
  },
});
